module.exports = __webpack_public_path__ + "static/media/btn_point_yleft_nor.6c770a1b.svg";